export class Constants {

    // public CHOICE_CLAZZS;
    // public QUESTION_CLAZZS;
    public QUESTION_TYPES = [
            { value: 'text', display: 'Text' },
            { value: 'clone', display: 'Clone' },
            { value: 'combo', display: 'Combo' },
            { value: 'radio', display: 'Radio' },
            { value: 'picture', display: 'Picture' },
            { value: 'sms', display: 'Sms' },
            { value: 'email', display: 'Email' },
            { value: 'check', display: 'Check' },
            { value: 'video', display: 'Video' },
            { value: 'vimeo', display: 'Vimeo' },
            { value: 'dynamic', display: 'Dynamic' }

        ];


    public QUESTION_TAGS = [
            {value:'email',display:'Email'},
            {value:'sms',display:'SMS'}
        ];
    // public POST_SYNCHRO_ACTION;
    // public QUESTION_CLAZZS : [key:string]:string;};

    public QUESTION_TYPES_TO_CLAZZ:  {[key:string]:string;} =
    {
        'text' :  'QuestionText',
        'clone': 'QuestionClone',
        'check' : 'QuestionCheck',
        'combo' : 'QuestionCombo',
        'radio' : 'ChoiceRadio',
        'sms' :  'QuestionText',
        'email' : 'QuestionEmail',
        'video' : 'QuestionVideo',
        'vimeo' : 'QuestionText',
        'picture' : 'QuestionPhotoText',
        'dynamic' : 'QuestionText'
    };

    public CHOICE_TYPES_TO_CLAZZ:  {[key:string]:string;} =
    {
        'text' :  'ChoiceText',
        'check' : 'ChoiceCheck',
        'combo' : 'ChoiceCombo',
        'radio' : 'ChoiceRadio',
        'sms' :  'ChoiceText',
        'email' : 'ChoiceEmail',
        'video' : 'ChoiceVideoCaptureCanon',
        'vimeo' : 'ChoiceText',
        'picture' : 'ChoicePhotoCaptureCanon',
        'dynamic' : 'ChoiceText'
    };

    constructor() {

        /*this.CHOICE_CLAZZS = [
            { value: 'ChoiceText', display: 'Text' },
            { value: 'ChoiceRadio', display: 'Radio' },
            { value: 'ChoiceCheck', display: 'Check' },
            { value: 'ChoiceCombo', display: 'Combo' },
            { value: 'ChoiceDate', display: 'Date' },
            { value: 'ChoiceEmail', display: 'Email' },
           //{ value: 'ChoicePhoto', display: 'Photo' },
            { value: 'ChoicePhotoCaptureCanon', display: 'Photo Capture Canon' },
            { value: 'ChoicePhotoCaptureAnimatedCanon', display: 'Photo Capture Anim Canon' },
            { value: 'ChoiceTimer', display: 'Timer' },
            { value: 'ChoiceCameraRingCanonMultiple', display: 'Camera Ring Canon Multiple' },
            { value: 'ChoiceCameraRingCanon', display: 'Camera Ring Canon' },
            //{ value: 'ChoiceVideo', display: 'Video' },
            { value: 'ChoiceVideoCaptureCanon', display: 'Video Capture Canon' },
            { value: 'ChoiceVideoCapture', display: 'Video Capture' }
        ];*/



        // this.QUESTION_CLAZZS =  = {"en" : ""};


        /*[
            { value: 'QuestionText', display: 'Text' },
            { value: 'QuestionCheck', display: 'Check' },
            { value: 'QuestionCombo', display: 'Combo' },
            { value: 'QuestionPhotoText', display: 'Photo Text' },
            { value: 'QuestionEmail', display: 'Email' },
            { value: 'QuestionVideo', display: 'Video' },
            { value: 'QuestionRadio', display: 'Radio' },
            { value: 'QuestionPhoto', display: 'Photo'},
            { value: 'QuestionPhotoAnimated', display: 'Photo Animated'}
        ];*/

        /*this.QUESTION_TYPES = [
            { value: 'text', display: 'Text' },
            { value: 'combo', display: 'Combo' },
            { value: 'radio', display: 'Radio' },
            { value: 'picture', display: 'Picture' },
            { value: 'sms', display: 'Sms' },
            { value: 'email', display: 'Email' },
            { value: 'check', display: 'Check' },
            { value: 'video', display: 'Video' },
            { value: 'vimeo', display: 'Vimeo' }

        ];*/

        /*this.POST_SYNCHRO_ACTION = [
            {index:0, clazz: 'picture_transformation.PictureTransformationProcessor', config: "", display: 'Picture Transformation' },
            {index:1, clazz: 'com.nomadlogic.juju.post_synchronization.subscription.NotifySubcribeUrls', config: "subscription-config.json", display: 'Subscription Hash Tag' },
            {index:2, clazz: 'com.nomadlogic.juju.post_synchronization.send_email.SendEmailProcessor', config: "email-config.json", display: 'Email' },
            {index:3, clazz: 'com.nomadlogic.juju.post_synchronization.send_sms.SendSmsProcessor', config: "sms-config.json", display: 'SMS' },
            {index:4, clazz: 'other', config: "other.json", display: 'Other' }

        ];*/
    }
}
